export function getJobInviteCreatedBy(params) {
  if (typeof params.status !== 'undefined') {
    if (params.status === 'draft') {
      return 'manual';
    }
    if (params.status === 'pending') {
      return 'manual';
    }
  }
  return undefined;
}

export function getJobInviteSentBy(params) {
  if (typeof params.status !== 'undefined') {
    if (params.status === 'draft') {
      return undefined;
    }
    if (params.status === 'pending') {
      return 'manual';
    }
  }
  return undefined;
}
